import { mediacoreApi } from '../mediacoreApi'

const is_compiler = process.env.GATSBY_IS_SITE_COMPILER === 'true'
const CLIENT_ID = process.env.GATSBY_CLIENTID

const summarySiteExtended = mediacoreApi.injectEndpoints({
  endpoints: (builder) => ({
    getSummarySite: builder.query({
      query: (siteId) => {
        const base = `core/summary/${CLIENT_ID}/`
        return is_compiler && siteId ? `${base}?site=${siteId}` : base
      },
      transformResponse: (data: any) =>
        data?.propiedades?.objects ? data : { ...data, propiedades: { objects: data.propiedades } },
    }),
  }),
  overrideExisting: false,
})

export const { useGetSummarySiteQuery } = summarySiteExtended
